const {
    proxyUrl,
    iframeAppUrl,
} = window.assetUrls;

const [proxyModule, iframeAppModule] = await Promise.all([
    import(proxyUrl),
    import(iframeAppUrl)
]);

const { getCustomerQrcode, getCustomerTokenData } = proxyModule;
const { iframePopupInit } = iframeAppModule;

const updateButtonUrl = (button, url) => {
  if (button) button.href = url;
};


// group1 - Mobile iPhone under X or other mobile devices
// group2 - Mobile iPhone X and above or iPad
// group3 - Desktop or non-iOS tablets
export const detectDeviceGroup = () => {

  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;

  const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

  // Basic 6_8 model width
  const iPhoneModel6_8Screen = 375;

  const isiPhone = /iPhone/.test(userAgent);
  const isiPad = /iPad/.test(userAgent) || 
                (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  const isMobile = /Mobi|Android/i.test(userAgent);

  const isIphoneXorAbove = isiPhone && (screenHeight >= 812); // X and above

  // --- Group classification ---
  if (isiPhone && isIOS) {
    if (screenWidth <= iPhoneModel6_8Screen && !isIphoneXorAbove) {
      return "group1"; // iPhone under X
    } else {
      return "group2"; // iPhone X and above
    }
  }

  if (isiPad) {
    return "group2"; // iPad
  }

  if (isMobile && !isIOS) {
    return "group1"; // Android phones or other mobile devices
  }

  return "group3"; // Desktop or non-iOS tablets
}

export function updateStorage (key, updates) {
  // Retrieve the object from local storage
  let storedObject = localStorage.getItem(key);

  // Check if the object exists in local storage
  if (storedObject) {
    // Parse the object
    storedObject = JSON.parse(storedObject);
    
    // Merge the updates into the existing object
    const updatedObject = { ...storedObject, ...updates };
    
    // Save the updated object back to local storage
    localStorage.setItem(key, JSON.stringify(updatedObject));
    
    // Return the updated object
    return updatedObject;
  } else {
    // Save the updated object back to local storage
    localStorage.setItem(key, JSON.stringify(updates));
    
    // Return the updated object
    return updates;
  }
}

const appendImage = (containerSelector, imageUrl) => {
  const containers = document.querySelectorAll(containerSelector);
  containers.forEach(container => {
    if (container && !container.innerHtml && imageUrl) {
      const img = document.createElement('img');
      img.src = imageUrl;
      img.alt = 'Fetched Image';
      container.innerHTML = ''; // Clear existing content
      container.appendChild(img);
    }
  })
};


export const processQRCode = async (urlParamKey, paramValue, qrCodeApiValue, initScanFn) => {
  const showAppLink = detectDeviceGroup() === "group2";
  const scanMobileBtns = document.querySelectorAll("[data-scan-redirect-btn]");
  const iframePopup = await iframePopupInit(initScanFn);
  if (paramValue) {
  const environments = {
    devqa: "proxy-qa",
    staging_and_production: "proxy"
    };
  const env = window.location.href.indexOf("dev") !== -1 ? environments.devqa : environments.staging_and_production;

    scanMobileBtns.forEach(btn => {
      if (showAppLink || !window.cross_platform_enable) {
        updateButtonUrl(btn, `${window.proxy_api_url ? window.proxy_api_url : `/apps/${env}`}/scan?${urlParamKey}=${paramValue}&referer=${btoa(window.location.href)}`);
      } else {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          iframePopup.open();
        });
      }
    })
  }
  if (!qrCodeApiValue) {
    const imageUrl = await getCustomerQrcode(paramValue);
    if(imageUrl) {
      appendImage("[data-qr-code]", imageUrl);
    } else {
      localStorage.removeItem('guest_scan');
    }
  } else {
    const imageUrl = await getCustomerQrcode(qrCodeApiValue);
    if(imageUrl) {
      appendImage("[data-qr-code]", imageUrl);
    } else {
      localStorage.removeItem('user_scan');
    }
  }
  const params = new URLSearchParams(window.location.search);
  if (params.has('crossplatform')) {
    iframePopup.open();
  }
};

export async function ensureTokenAndQRCode() {
  const tokenKey = 'user_scan'; // Key for session storage

  // Retrieve and parse user_scan from session storage
  let tokenData = JSON.parse(localStorage.getItem(tokenKey));

  // Return the object if it already exists
  if (tokenData?.token && tokenData?.qr_code) {
      return tokenData;
  }

  try {
    // Fetch token and QR code using the proxy API
    const data = await getCustomerTokenData();
    if (data.status === false) {
      throw new Error(data.message);
    } 
    const { token, qr_code } = data

    // Construct the tokenData object
    tokenData = { token, qr_code };

    // Save the fetched data to session storage
    updateStorage(tokenKey, tokenData);

    return tokenData;
  } catch (error) {
    //console.error('Error fetching token and QR code:', error);
    return null;
  }
}

export function isUserHasScan() {
  const guestScan = JSON.parse(localStorage.getItem("guest_scan"));
  const userScan = JSON.parse(localStorage.getItem("user_scan"));

  return (guestScan?.has_scan === true) || (userScan?.has_scan === true);
}